(ns common.schema.entities.survey-batch.options)

(def batch-status-options
  [{:key :survey-batch.status/draft
    :label "Draft"}
   {:key :survey-batch.status/sent
    :label "Sent"}
   {:key :survey-batch.status/closed
    :label "Closed"}])
